import { memo, useCallback, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { EXIST_LOCAL_STORAGE } from '../../../services/constants';
import { getStorage } from '../../../services/helperFunctions';
import { FilterProps } from '../../../services/interface/bonds';

const CreateFilter: React.FC<FilterProps> = ({ show, toggle, createBondsFilter, filterData, handleFilterListPagination }) => {
    const [filterName, setFilterName] = useState('');
    const [isError, setIsError] = useState(false);

    const handleSubmit = useCallback(
        (e: any) => {
            e.preventDefault();
            if (filterName.trim() === '') {
                setIsError(true);
                return;
            }
            setIsError(false);

            const details: Array<{ html_field_name: string; html_field_value: string }> = [];

            Object.entries(filterData).forEach(([key, value]) => {
                if (key !== 'user_id')
                    details.push({
                        html_field_name: String(key),
                        html_field_value: key === 'status' ? (value ? 'Inactive' : 'Active') : String(value),
                    });
            });
            const body: any = {
                filter_name: filterName,
                user_id: getStorage(EXIST_LOCAL_STORAGE.USER_ID),
                promoted_order: 0,
                featured_search: true,
                details,
            };

            createBondsFilter(body).then((data: any) => {
                toggle();
                handleFilterListPagination();
            });
        },
        [filterName, createBondsFilter, filterData, handleFilterListPagination, toggle]
    );
    const handleNameChange = useCallback((value: string) => {
        setFilterName(value);
        setIsError(false);
    }, []);

    return (
        <Modal
            show={show}
            onHide={toggle}
            size="sm"
            dialogClassName="modal-100w"
            centered
            aria-labelledby="example-custom-modal-styling-title-lg"
        >
            <Modal.Header closeButton className="bg-theme">
                <Modal.Title id="example-custom-modal-styling-title-lg" className="modal-heading h5">
                    Save Filter As
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    onChange={(event: any) => handleNameChange(event?.target?.value)}
                                    className="form-control"
                                    autoFocus
                                    placeholder="Enter Filter Name"
                                />
                            </div>
                            {isError && <p className="text-danger text-start text-sm">Please enter the filter name</p>}
                            <button className="btn btn-light border-dark btn-sm" type="submit">
                                Save Filter
                            </button>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default memo(CreateFilter);
